import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export type DescriptionProps = {
  children: ReactNode;
};

export const Description = ({ children }: DescriptionProps) => {
  return (
    <Typography variant="body2" color={'textSecondary'}>
      {children}
    </Typography>
  );
};
